import "./BlogPreview.css";

import blogImg from "../../Images/Blogs/blog.png";
import arrow from "../../Images/Icons/arrow.png";
import { useNavigate } from "react-router-dom";
const BlogPreviewSingle = () => {
    const LinkTo = useNavigate();
    return (
        <>
            <div className="blogImagePreview">
                <div className="imgNMore">
                    <img className="mainImgBlg" src={blogImg} alt="" />
                    <div className="readMorePreview">
                        <span class="halfCircleInner"></span>
                        <span class="halfCircleInner"></span>
                        <div onClick={()=> LinkTo("/blog/graphic-design")} className="text">
                            <span>Read</span>
                            <span>Now</span>
                        </div>
                        <div className="icon">
                            <img src={arrow} alt="" />
                            <img src={arrow} alt="" />
                        </div>
                    </div>
                </div>

                <div className="blogPreviewTitleOne">
                    UI/UX Design - A Complete Guide
                </div>

            </div>
        </>
    )
}
export default BlogPreviewSingle;